module.exports = __webpack_public_path__ + "static/media/Programming_Essentials_in_C.23a7b5df.png";